<script context="module">
  export const audioElements = new Set();

  export function stopAll() {
    console.log('stopall');
    audioElements.forEach((element) => {
      element.pause();
    });
  }
</script>

<script>
  import { onMount, createEventDispatcher } from "svelte";
  import { fade, fly, scale } from "svelte/transition";
  import { linear, cubicIn } from "svelte/easing";
  import PlaySvg from "./Play.svelte";
  import PauseSvg from "./Pause.svelte";
  import { hexToRgbA } from "./helpers.js";

  import { PlayIcon, PauseIcon } from "svelte-feather-icons";

  export let data;
  export let h;
  export let paused = true;
  export let bg;
  export let fg;
  export let percentage;
  export let showTranscript;
  export let universalMode;

  let audioEl;
  let showControls = true;

  let showControlsTimeout;
  let docked = true;
  let mini = false;
  let duration;
  let currentTime;

  function formatTime(seconds) {
    if (isNaN(seconds)) return "...";

    const minutes = Math.floor(seconds / 60);
    seconds = Math.floor(seconds % 60);
    if (seconds < 10) seconds = "0" + seconds;

    return `${minutes}:${seconds}`;
  }

  $: {
    percentage = currentTime / duration || 0;
  }

  $: time = formatTime(duration - currentTime);

  onMount(() => {
    if (data.audio) {
      audioElements.add(audioEl);
    }

    // return () => audioElements.delete(audioEl);
  });

  function stopOthers() {
    audioElements.forEach((element) => {
      if (element !== audioEl) element.pause();
    });

  }

  function togglePlayBack() {
    if (paused === true) {
      audioEl.play();
    } else if (paused !== true) {
      audioEl.pause();
    }
  }

  function seek(value) {
    audioEl.currentTime = value;
  }

  function handleMove(e) {
    clearTimeout(showControlsTimeout);
    showControlsTimeout = setTimeout(() => (showControls = false), 2500);
    showControls = true;

    if (!e.touches && !(e.buttons & 1)) return; // mouse not down
    if (!e.touches && !duration) return; // video not loaded yet

    const { left, right } = this.getBoundingClientRect();
    let ex = e.touches ? e.touches[0].clientX : e.clientX;

    seek((duration * (ex - left)) / (right - left));
  }

  function handleTouchClick(e) {
    clearTimeout(showControlsTimeout);
    showControlsTimeout = setTimeout(() => (showControls = false), 2500);
    showControls = true;

    const { left, right } = this.getBoundingClientRect();
    let ex = e.touches ? e.touches[0].clientX : e.clientX;

    seek((duration * (e.clientX - left)) / (right - left));
  }

  function handleKeyDown(e) {
    e.keyCode == 27; // escape
    if (showTranscript) showTranscript = false;
    if (showPlayer) showPlayer = false;
  }
</script>

<audio
  id="audio-file"
  bind:this={audioEl}
  src={data.audio}
  bind:paused
  bind:duration
  bind:currentTime
  on:play={stopOthers}
  preload="metadata"
/>

{#if audioEl}


  <div class="player-controls" style="--h:{h}px" >
    {#if !mini}
      <div class="transport">
        {#if !paused}
          <button
          transition:fade
            class="seek-btn"
            on:click={() => seek(audioEl.currentTime - 10)}>-10</button
          >
        {/if}
          <button on:click={togglePlayBack} class="play-btn"
            ><PlaySvg fg={fg} bind:paused bind:universalMode /></button
          >
  {#if !paused}
          <button
            transition:fade
            class="seek-btn"
            on:click={() => seek(audioEl.currentTime + 10)}>+10</button
          >
        {/if}
      </div>

      
        <div class="seekbar-wrapper">
         {#if !paused}
        <div class="seekbar" transition:fly={{y:100}}>
          
          <div class="countdown">{time}</div>
          <progress
            style="--progress-bg:{hexToRgbA(bg, 0.5)}"
            value={percentage * 100}
            max="100"
            on:click={handleTouchClick}
            on:mousemove={handleMove}
            on:touch={handleTouchClick}
            on:touchmove={handleMove}
            transition:fade
          />
          <div class="transcript">
            <button on:click={() => (showTranscript = !showTranscript)}
              >Transcript</button
            >
          </div>
          
        </div>
         {/if}
         </div>
    {/if}
  </div>
  {/if}


<!-- svelte-ignore a11y-media-has-caption -->
<style>
  .seek-btn {
    font-size: 1rem;
  }

  .player-controls {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height:100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.20));
    hyphens: none;
    padding:0rem 1rem 0 1rem;
  }

.play-btn{
  padding-bottom:0;
}

  .transport,
  .seekbar {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .transport{
  }

  .seekbar-wrapper{
    min-height:2.5rem;
    position: absolute;
    bottom:0;
    padding: 0 1 rem;
    width:100%;
  }

  .seekbar {
    width: 100%;
    justify-content: center;
    align-items: center;
    position:absolute;
    bottom:0;
    height:2em;
    padding:0 .5rem;
  }



  .seekbar,
  .transcript {
    font-size: 1rem;
  }

  .seekbar button {
    vertical-align: bottom;
  }

  progress {
    -webkit-appearance: none;
    appearance: none;
    z-index: 50;
    cursor: pointer;
    height: 12px;
    margin: 6px 1em;
    width: 100%;
  }

  progress::-webkit-progress-bar {
    background-color: var(--progress-bg);
    /* border-radius: 1rem; */
    /* border: 1px solid currentColor; */
    height: 8px;
  }

  progress::-webkit-progress-value {
    background-color: currentColor;
    /* border-radius: 1rem; */
    border: 1px solid currentColor;
  }

  .transcript button {
    text-transform: uppercase;
    font-size: 0.75em;
    letter-spacing: 1px;
  }

  .readmore {
    margin: 0;
    text-align: center;
    position: relative;
    /* text-decoration: underline;
    text-underline-offset: 0.2em;
    text-transform: uppercase; */
    backg-color: var(--fg);
    color: black;
    border-radius: 0.1em;
    padding: 0.1em 0.5em;
    /* mix-blend-mode: screen; */
    letter-spacing: 1px;
  }

  .bg-wrapper {
    border: 2px solid yellow;
    background-position: center center;
  }
</style>
